import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=532b868e&scoped=true&"
import script from "./configuration.vue?vue&type=script&lang=js&"
export * from "./configuration.vue?vue&type=script&lang=js&"
import style0 from "./configuration.vue?vue&type=style&index=0&id=532b868e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532b868e",
  null
  
)

export default component.exports